export default __webpack_public_path__ + "static/feature_02-daaa9d98100c9023e8f8d61278365934.png";